export enum ProductType {
    Mug = 'Mug',
    Bowl = 'Bowl',
    Plate = 'Plate',
    Figure = 'Figure',
    Other = 'Other'
}
